import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Loader } from '@components/Loader/Index';
import { User } from '@data/models/user.interface';
import { Error404, NoAccess } from '@pages/Error/Index';
import { userCanSeeRoute } from '@plugins/router/default';
import { flatRoutes } from '@plugins/router/router';
import { Permissions } from 'constants/permissions';
import { Routes as AppRoutes } from 'constants/routes';

interface Props {
  user: User;
}

const Router = ({ user }: Props): JSX.Element => {
  const userRoutes = flatRoutes.filter((navRoute) =>
    userCanSeeRoute(user, navRoute),
  );

  /**
   * Most routes declare no permission at all, so counting reachable routes never
   * reaches zero: the timesheet permission is what actually tells Nina apart from
   * a user who was granted nothing.
   */
  const canUseNina = user.permissions.includes(Permissions.Timesheets.List);

  if (!canUseNina) {
    return <NoAccess />;
  }

  return (
    (user.isAuthenticated && (
      <Suspense fallback={<Loader />}>
        <Routes location={location}>
          <Route
            path="/"
            element={<Navigate to={AppRoutes.DASHBOARD_PATH} />}
          />

          {userRoutes.map((navRoute) => (
            <Route
              key={navRoute.path}
              path={navRoute.path}
              element={navRoute.component || <></>}
            />
          ))}

          <Route path="*" element={<Error404 />} />
        </Routes>
      </Suspense>
    )) || <></>
  );
};

export default Router;
